import { styled } from 'styled-components';

import { Hyperlink } from '#/components/Hyperlink/Hyperlink';
import { colors, spacing } from '#/theme/theme';

export const PageFooterCentralLinksHolder = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[24]};

  > *:not(:last-child) {
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: -12px;
      height: 16px;
      width: 1px;
      background: currentcolor;
      pointer-events: none;
    }
  }
`;

export const PageFooterCentralLink = styled(Hyperlink)`
  position: relative;
  font-size: 16px;
  font-weight: normal;
  color: ${colors.lightContentGrey};
`;
